export default "__VITE_ASSET__978e9cdf__"